import { clipObjectUrl, clipUrl, splitSegments } from "./audioStore";

let current = null;

export { splitSegments };

export const stopNarration = () => {
  if (current) {
    if (current.pause) { current.pause(); current.src = ""; }
    current = null;
  }
};

// Plays a scientist narration part (briefing, note_25, ...), optionally one paragraph (seg), from the local clip store.
// Resolves true when playback finished, false if audio failed/was interrupted.
export const playNarration = (part, { seg, onEnd } = {}) =>
  new Promise((resolve) => {
    stopNarration();
    const token = {};
    current = token;
    let settled = false;
    const done = (ok, audio, src) => {
      if (settled) return;
      settled = true;
      if (current === audio || current === token) current = null;
      if (src) URL.revokeObjectURL(src);
      onEnd?.(ok);
      resolve(ok);
    };
    clipObjectUrl(clipUrl(`narration/${part}${seg === undefined ? "" : `?seg=${seg}`}`))
      .then((src) => {
        if (current !== token) { if (src) URL.revokeObjectURL(src); done(false); return; }
        if (!src) { done(false); return; }
        const audio = new Audio(src);
        current = audio;
        audio.onended = () => done(true, audio, src);
        audio.onerror = () => done(false, audio, src);
        audio.onpause = () => { if (!audio.ended && current !== audio) done(false, audio, src); };
        audio.play().catch(() => done(false, audio, src));
      })
      .catch(() => done(false));
  });

export const playUrl = (url) => {
  stopNarration();
  const audio = new Audio(url);
  current = audio;
  return new Promise((resolve, reject) => {
    audio.onerror = () => reject(new Error("audio failed"));
    audio.onended = resolve;
    audio.play().catch(reject);
  });
};
